import React from "react";
import * as Yup from "yup";
import { getValidationRule, TranslatedText } from "../../../helpers/helpers";

import { Trans } from "react-i18next";
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,
} from "../../../helpers/enums";
import {
  CONTRACTS_ADD_TO_ACCOUNT_ADMIN,
  getEvictionForMutation,
} from "../../../helpers/mutations";
const model = (contracts, activeStep) => {
  let formField = contracts.map((element, index) => {
    return {
      [`codiceUtenza-${index}`]: {
        name: "codiceUtenza-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.codiceUtenza" />
        ),
        placeholder: (
          <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
        ),
        type: "input",
        readonly: true,
      },
      [`intestatario-${index}`]: {
        name: "intestatario-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.intestatario" />
        ),
        placeholder: (
          <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
        ),
        type: "input",
        readonly: true,
      },
      [`puntoDiFornitura-${index}`]: {
        name: "puntoDiFornitura-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.puntoDiFornitura" />
        ),
        placeholder: (
          <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
        ),
        type: "input",
        readonly: true,
      },
      [`verbale${index}`]: {
        name: "verbale".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.verbale" />
        ),
        labelSummary: true,
        type: "s3File",
        customPathS3: "upload/",
        prefixFileName: "verbale-nomina",
        allowedExtensions: [
          "application/pdf",
          "image/jpeg",
          "image/png",
          "text/plain",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        allowDragAndDrop: false,
        activeStep: activeStep,
        infoUploadModalMessage: <TranslatedText i18nKey="common.fileAllowed" />,
      },
      [`codiceFiscaleCondominio-${index}`]: {
        name: "codiceFiscaleCondominio-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.codiceFiscaleCondominio" />
        ),
        placeholder: (
          <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
        ),
        type: "input",
      },
      [`codiceDestinatario-${index}`]: {
        name: "codiceDestinatario-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.codiceDestinatario" />
        ),
        placeholder: (
          <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
        ),
        type: "input",
      },
      [`copiaCFCondominio-${index}`]: {
        name: "copiaCFCondominio-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.copiaCFCondominio" />
        ),
        labelSummary: true,
        invalidErrorMsg: (
          <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
        ),
        type: "s3File",
        customPathS3: "upload/",
        prefixFileName: "cf_condominio",
        allowedExtensions: [
          "application/pdf",
          "image/jpeg",
          "image/png",
          "text/plain",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        allowDragAndDrop: false,
        activeStep: activeStep,
        infoUploadModalMessage: <TranslatedText i18nKey="common.fileAllowed" />,
      },
      [`bollettaOnline-${index}`]: {
        name: "bollettaOnline-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.bollettaOnline" />
        ),
        type: "radio",
        onChange: (selected, values, setFieldValue) => {
          setFieldValue("emailBollettaOnline-aggiorna-".concat(index), "");
        },
        options: [
          {
            label: <TranslatedText i18nKey="common.yes" />,
            value: "true",
            grid: { xs: 6, md: 2 },
          },
          {
            label: <TranslatedText i18nKey="common.no" />,
            value: "false",
            grid: { xs: 6, md: 2 },
          },
        ],
      },
      [`emailBollettaOnline-aggiorna-${index}`]: {
        name: "emailBollettaOnline-aggiorna-".concat(index),
        label: (
          <TranslatedText i18nKey="cases.associa.contract.admin.emailBollettaOnline" />
        ),
        placeholder: (
          <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
        ),
        readonly: (values) => {
          return !(values[`bollettaOnline-${index}`] === "true");
        },
        disabled: (values) => {
          return !(values[`bollettaOnline-${index}`] === "true");
        },
        type: "input",
      },
    };
  });
  let formFieldObject = {};
  Object.assign(formFieldObject, ...formField);

  return {
    formId: CaseForms.AssociaContrattoAmministratore,
    formField: { ...formFieldObject },
  };
};
// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = (contracts) => {
  let initialValuesMapping = contracts.map((element, index) => {
    return {
      ["codiceUtenza-".concat(index)]: element.userCode
        ? element.userCode
        : "-",
      ["intestatario-".concat(index)]: element.intestatario
        ? element.intestatario
        : "-",
      ["puntoDiFornitura-".concat(index)]: element.supplyPoint
        ? element.supplyPoint
        : "-",
      ["verbale".concat(index)]: "",
      ["codiceFiscaleCondominio-".concat(index)]: "",
      ["codiceDestinatario-".concat(index)]: "",
      ["copiaCFCondominio-".concat(index)]: "",
      ["bollettaOnline-".concat(index)]: "",
      ["emailBollettaOnline-aggiorna-".concat(index)]: "",
    };
  });
  let initialValuesMappingObject = {};
  Object.assign(initialValuesMappingObject, ...initialValuesMapping);
  return initialValuesMappingObject;
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = (contracts) => {
  const validationNumber = getValidationRule("number");
  let yupObject = contracts.map((element, index) => {
    return Yup.object().shape({
      ["codiceUtenza-".concat(index)]: Yup.string().required(
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      ["intestatario-".concat(index)]: Yup.string().required(
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      ["puntoDiFornitura-".concat(index)]: Yup.string().required(
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      ["verbale".concat(index)]: Yup.string().required(
        <TranslatedText i18nKey="cases.errors.required" />
      ),
      ["codiceFiscaleCondominio-".concat(index)]: Yup.string()
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        )
        .max(11, <TranslatedText i18nKey="errors.registration.admin.fc.long" />)
        .min(
          11,
          <TranslatedText i18nKey="errors.registration.admin.fc.short" />
        )
        .matches(validationNumber, {
          message: (
            <TranslatedText i18nKey="errors.registration.admin.fc.match" />
          ),
        }),
      ["codiceDestinatario-".concat(index)]: Yup.string()
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        )
        .max(7, <TranslatedText i18nKey="errors.registration.admin.fc.long" />)
        .min(7, <TranslatedText i18nKey="errors.registration.admin.fc.short" />)
        .matches("^[a-zA-Z0-9]+$", {
          message: (
            <TranslatedText i18nKey="cases.associa.contract.admin.error.codice_cliente.invalid" />
          ),
        }),
      ["bollettaOnline-".concat(index)]: Yup.string().required(
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      ["emailBollettaOnline-aggiorna-".concat(index)]: Yup.string()
        .email(
          <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
        )
        .when("bollettaOnline-".concat(index), {
          is: (field) => field === "true",
          then: Yup.string().required(
            <TranslatedText i18nKey="cases.request_info.errors.required" />
          ),
        }),
    });
  });
  return [...yupObject];
};
// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (contracts) => {
  let getLayoutObject = contracts.map((element, index) => {
    let contractIdLabel = element.integraContractCode;
    return {
      chapterName: (
        <Trans
          i18nKey="cases.associa.contract.admin.title"
          values={{ contractLabel: contractIdLabel }}
          parent=""
        />
      ),
      chapter: true,
      noSummaryModal: true,
      title: (
        <TranslatedText i18nKey="cases.voltura.layout.dati_contratto.title" />
      ),
      fields: [
        {
          index: index,
          fieldName: "codiceUtenza-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          index: index,
          fieldName: "intestatario-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          index: index,
          fieldName: "puntoDiFornitura-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          index: index,
          fieldName: "verbale".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          index: index,
          fieldName: "codiceFiscaleCondominio-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          index: index,
          fieldName: "codiceDestinatario-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          index: index,
          fieldName: "copiaCFCondominio-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <div className="info-label">
              <span className="gc-icon-functional-attention-2-col">
                <span className="path1" />
                <span className="path2" />
              </span>
              <p>
                <TranslatedText i18nKey="cases.associa.contract.admin.codiceFiscale.InfoLabel" />
              </p>
            </div>
          ),
          grid: {
            xs: 12,
            md: 12,
          },
        },
        {
          index: index,
          fieldName: "bollettaOnline-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          index: index,
          fieldName: "emailBollettaOnline-aggiorna-".concat(index),
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <div className="info-label">
              <span className="gc-icon-functional-attention-2-col">
                <span className="path1" />
                <span className="path2" />
              </span>
              <p>
                <TranslatedText i18nKey="cases.associa.contract.admin.bollettaOnline.InfoLabel" />
              </p>
            </div>
          ),
          grid: {
            xs: 12,
            md: 12,
          },
        },
      ],
    };
  });
  return [...getLayoutObject];
};

// Contiene dettagli sul case form
const formDetails = (contracts) => {
  return {
    title: <TranslatedText i18nKey="associate-contact.titleDetailsContract" />,
    summary: true,
    stepper: contracts.length > 1 ? CaseStepperType.Full : CaseStepperType.NONE,
    helpText: null,
    backTo: "/contracts/add",
    backToText: (
      <TranslatedText i18nKey="associate-contact.titleSecondScreen" />
    ),
    blockIfNoContracts: false,
    successText: (
      <div>
        <p>
          <p>
            <TranslatedText i18nKey="associate-contact.successAddContracts" />
          </p>
          <p>
            <TranslatedText i18nKey="associate-contact.modalBodyNote" />
          </p>
        </p>
      </div>
    ),
  };
};
const mutation = {
  type: CaseMutationType.Custom,
  mutation: CONTRACTS_ADD_TO_ACCOUNT_ADMIN,
  refetchQueries: getEvictionForMutation("associateCondominiumContract"),
};
const translatedMappingFunction = (payload, contracts) => {
  return {
    contracts: contracts.map((element, index) => {
      return {
        integraContractCode: element.integraContractCode,
        contractId: element.contractId,
        condominiumFiscalCode:
          payload["codiceFiscaleCondominio-".concat(index)],
        condominiumFiscalCodeAttachment: payload[
          "copiaCFCondominio-".concat(index)
        ]
          ? true
          : false,
        onlineBillActivation:
          payload["bollettaOnline-".concat(index)] === "true",
        onlineBillEmail: payload["emailBollettaOnline-aggiorna-".concat(index)],
        SDICode: payload["codiceDestinatario-".concat(index)],
        token: element.token,
        attachments: [
          {
            type: "VERBAL",
            data: payload["verbale".concat(index)],
          },
          {
            type: "CONDOMINIUM_FC",
            data: payload["copiaCFCondominio-".concat(index)],
          },
        ].filter((element) => element.data),
      };
    }),
  };
};

const translatedInverseMappingFunction = (payload, values, contracts) => {
  let mappingObject = contracts.map((element, index) => {
    return {
      [`req.contracts[${index}].condominiumFiscalCode`]:
        "codiceFiscaleCondominio-".concat(index),
      [`req.contracts[${index}].condominiumFiscalCodeAttachment`]:
        "copiaCFCondominio-".concat(index),
      [`req.contracts[${index}].onlineBillActivation`]:
        "bollettaOnline-".concat(index),
      [`req.contracts[${index}].onlineBillEmail`]:
        "emailBollettaOnline-aggiorna-".concat(index),
      [`req.contracts[${index}].SDICode`]: "codiceDestinatario-".concat(index),
      [`req.contracts[${index}].attachments`]: "verbale".concat(index),
    };
  });
  let mapping = {};
  Object.assign(mapping, ...mappingObject);
  const errorsFields = payload.map(({ field, message }) => {
    return { field, message };
  });

  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};

const main = (
  excludeSteps,
  counter,
  signDigital,
  webviewPopup,
  webviewRedirectPopup,
  buttonMatricolaContatoreCase,
  privacyLink,
  privacyCtaLabel,
  activeStep,
  contractsState
) => {
  let contracts = contractsState ? [...contractsState] : [];
  const translatedMapping = (payload, contract) => {
    return translatedMappingFunction(payload, contract);
  };
  const translatedInverseMapping = (payload, values) => {
    return translatedInverseMappingFunction(payload, values, contracts);
  };
  return {
    model: model(contracts, activeStep),
    validationSchema: getValidationSchema(contracts),
    initialValues: initialValues(contracts),
    layout: getLayout(contracts),
    formDetails: formDetails(contracts),
    translatedMapping,
    translatedInverseMapping,
    mutation,
  };
};

export default main;
